<script>
  import { RuleBlock } from '@client/components/rule-block';

  export let row = {};
</script>

<div class="filename">{row.title}</div>

{#if row.width && row.height}
  <small class="dimensions">{row.width}x{row.height}</small>
{/if}

<div class="rulename">
  <RuleBlock text="[[vid:{row.rulename}]]" />
</div>

<style lang="scss">
  .rulename {
    display: inline-flex;
    margin-top: var(--margin-base);
  }

  .dimensions {
    color: var(--color-gray-600);
    display: block;
    margin-top: var(--margin-small);
  }
</style>
